import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Twitter, Youtube, Globe, Smartphone } from 'lucide-react';

const FOOTER_LINKS = {
  'localliink.com': [
    { label: 'About localliink.com', href: '/about' },
    { label: 'Press Centre', href: '/press' },
    { label: 'Careers', href: '/careers' },
    { label: 'Investor Relations', href: '/investor-relations' },
    { label: 'Trust & Safety', href: '/trust-safety' },
  ],
  'Explore': [
    { label: 'Travel Guides & City Stories', href: '/travel-guides' },
    { label: 'Loved by Travellers', href: '/loved-by-travellers' },
    { label: 'Insights & Data', href: '/insights' },
    { label: 'Reviews', href: '/reviews' },
    { label: 'Trending Destinations', href: '/explore' },
  ],
  'LiinkShopping': [
    { label: 'Coming Soon ✨', href: '/liink-shopping' },
    { label: 'Spend Wallet Credits', href: '/spend-wallet-credits' },
  ],
  'Help': [
    { label: 'Customer Support', href: '/customer-support' },
    { label: 'Cancellation Policy', href: '/cancellation-policy' },
    { label: 'Refund Status', href: '/refund-status' },
    { label: 'Manage Booking', href: '/my-bookings' },
    { label: 'List Your Property', href: '/list-your-property' },
  ],
  'Programmes': [
    { label: 'Staff Training (STP)', href: '/staff-training-programme' },
    { label: 'Skill Development (SDPH)', href: '/skill-development-programme' },
    { label: 'LCP Certification Badge', href: '/liink-certification' },
    { label: 'Partner with us', href: '/list-your-property' },
  ],
  'Connect': [
    { label: 'Connect with us', href: '/connect' },
    { label: 'Travel Blog', href: '/travel-guides' },
    { label: 'Sitemap', href: '/explore' },
  ],
};

export const Footer = () => {
  return (
    <footer className="bg-[#FAFAFA] border-t border-gray-200 mt-24 pt-16 pb-8" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-8 mb-12">
          {/* Brand column */}
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="block mb-3" data-testid="footer-logo">
              <h2 className="text-2xl font-black tracking-tight text-black">
                local<span className="text-[#FF0059]">liink</span>.com
              </h2>
              <p className="text-xs text-gray-500 mt-1">Building India&apos;s Hyperlocal Bookingplace</p>
            </Link>
            <p className="text-sm text-gray-600 mt-4 leading-relaxed">
              Real properties. Real reviews. Real prices. Discover the best of Punjab, Haryana & Chandigarh.
            </p>
            <div className="mt-5 flex items-center gap-3" data-testid="social-icons">
              <a href="/" aria-label="Facebook" className="text-gray-400 hover:text-[#FF0059] transition-colors">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="/" aria-label="Instagram" className="text-gray-400 hover:text-[#FF0059] transition-colors">
                <Instagram className="h-5 w-5" />
              </a>
              <a href="/" aria-label="Twitter" className="text-gray-400 hover:text-[#FF0059] transition-colors">
                <Twitter className="h-5 w-5" />
              </a>
              <a href="/" aria-label="YouTube" className="text-gray-400 hover:text-[#FF0059] transition-colors">
                <Youtube className="h-5 w-5" />
              </a>
            </div>
          </div>

          {Object.entries(FOOTER_LINKS).map(([section, links]) => (
            <div key={section} data-testid={`footer-col-${section.toLowerCase()}`}>
              <h3 className="font-bold mb-4 text-sm text-black uppercase tracking-wider">{section}</h3>
              <ul className="space-y-2.5">
                {links.map((l) => (
                  <li key={l.label}>
                    <Link to={l.href} className="text-sm text-gray-600 hover:text-[#FF0059] hover:underline transition-colors">
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-200 pt-6 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div className="flex flex-wrap items-center gap-5 text-sm text-gray-600">
            <button className="flex items-center gap-2 hover:text-[#FF0059] transition-colors" data-testid="footer-language">
              <Globe className="h-4 w-4" />
              English (IN)
            </button>
            <button className="hover:text-[#FF0059] transition-colors" data-testid="footer-currency">
              ₹ INR
            </button>
            <span className="hidden md:block">·</span>
            <span className="text-xs">Get the app:</span>
            <button className="inline-flex items-center gap-1 px-3 py-1.5 border border-gray-300 rounded-lg hover:border-[#FF0059] transition-colors">
              <Smartphone className="h-3.5 w-3.5" />
              <span className="text-xs font-semibold">iOS · Android</span>
            </button>
          </div>
          <p className="text-xs text-gray-500" data-testid="footer-copyright">
            © 2026 Liink Media &amp; Hospitality LLP · localliink.com · All rights reserved · Made in India
          </p>
        </div>
      </div>
    </footer>
  );
};
